module.exports = __webpack_public_path__ + "static/media/fourthpdflogo.6954e353.png";